/**
 * BSS custom — SBCB2BBS-4949
 * Bảng gộp Variant | Info | Tiered pricing | Quantity + Total + Add to cart, thay bảng variant cũ (bulk buy table).
 * - Variant / Info: /products/<handle>.js (ảnh, option, SKU, barcode/UPC). Stock đọc từ bảng cũ (ẩn nhưng vẫn còn trong DOM).
 * - Tiered pricing / Total: rule Volume Pricing (BSS) đang áp cho khách + sản phẩm, tính bằng logic của app.
 * - Quantity: theo rule Quantity Increment (BSS) của từng variant. 1 → qiSmallMax nhảy bậc 1, từ đó trở lên nhảy theo bậc của rule.
 * - Add to cart: /cart/add.js nhiều variant một lần, mở mini cart của theme, ở lại trang sản phẩm.
 * - Cart page: nút +/− và ô số lượng của theme dùng cùng bước nhảy; validate QI của app cho phép 1 → qiSmallMax.
 * Khách không thỏa điều kiện / lỗi dữ liệu → không render, bảng cũ giữ nguyên.
 */
(function () {
  'use strict';

  var CONFIG = {
    // Handle sản phẩm được bật. [] = mọi sản phẩm có bảng variant cũ.
    productHandles: [],
    // Chỉ hiện với khách có 1 trong các tag này. [] = khách thuộc ít nhất 1 rule Volume Pricing.
    customerTags: [],
    // Chèn bảng mới vào trước block này (block bảng VP của BSS trong theme).
    insertBeforeSelector: '.f8pr-bss_quantity_table',
    // Bảng variant cũ của theme: nguồn đọc Stock, bị ẩn khi bảng mới render xong.
    chartTableSelector: '.f8pr-bulk_buy_table',
    hideDefaultVpTable: true,
    hideChartTable: true,
    // Mức Tiered pricing (dòng được tô + đơn giá) tính theo:
    // 'row'  = số lượng của chính dòng (màu) đó
    // 'rule' = theo loại rule VP như app tính ở cart (rule cấp sản phẩm cộng dồn các màu)
    tierQuantityBy: 'rule',
    // Rule QI theo variant: từ 1 đến số này nhảy bậc 1, lớn hơn thì nhảy theo bậc của rule (vd 6, 12, 18…). 0 = tắt, theo đúng rule.
    qiSmallMax: 5,
    // Cart page: chỉnh nút +/− / ô số lượng của theme theo bước nhảy trên (theme Xtra: a.incr / a.decr).
    cartQtyFix: true,
    labels: {
      variant: 'Variant',
      info: 'Info',
      tiers: 'Tiered pricing',
      quantity: 'Quantity',
      increase: 'Increase quantity',
      decrease: 'Decrease quantity',
      stock: 'Stock',
      sku: 'SKU',
      upc: 'UPC',
      inStock: 'In stock',
      outOfStock: 'Out of stock',
      tierQty: 'Buy',
      tierPrice: 'Price / unit',
      // Chỉ hiện số lượng bắt đầu của mỗi mức. Muốn hiện cả khoảng: '{from} – {to}'
      qtyRange: '{from}',
      qtyOpen: '{from}+',
      noTiers: 'Price / unit',
      // {qty}: tổng số lượng, {price}: tổng tiền
      total: 'Total ({qty}): {price}',
      addToCart: 'ADD TO CART',
      adding: 'ADDING…',
      added: 'Added to cart',
      // {step}: bội số của rule Quantity Increment
      multipleOf: 'Quantity must be a multiple of {step}',
      addError: 'Could not add to cart. Please try again.'
    },
    waitTimeoutMs: 15000
  };

  var ROOT_CLASS = 'bss-vp-merged';
  var QB_TYPE = { PRODUCT_LEVEL: 0, ORDER_LEVEL: 1, VARIANT_LEVEL: 2 };
  var QI_TYPE = { VARIANT_QUANTITY: 0, PRODUCT_QUANTITY: 1, ORDER_QUANTITY: 2 };

  // ---------- helpers ----------

  function getHandle() {
    var path = window.location.pathname;
    var idx = path.indexOf('/products/');
    if (idx === -1) return null;
    return decodeURIComponent(path.slice(idx + '/products/'.length).split('/')[0] || '') || null;
  }

  function isEnabledFor(handle) {
    return !!handle && (!CONFIG.productHandles.length || CONFIG.productHandles.indexOf(handle) !== -1);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fill(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (m, key) {
      return values[key] !== undefined ? values[key] : m;
    });
  }

  function sizedImage(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function hasValue(v) {
    return v !== null && v !== undefined && v !== '';
  }

  function waitFor(check, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var start = Date.now();
      (function tick() {
        if (check()) return resolve();
        if (Date.now() - start > timeoutMs) return reject(new Error('timeout'));
        setTimeout(tick, 200);
      })();
    });
  }

  function getProductId() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (meta && meta.product && meta.product.id) return Number(meta.product.id);
    var el = document.querySelector('[bss-b2b-main-product-form] [bss-b2b-product-id]');
    return el ? Number(el.getAttribute('bss-b2b-product-id')) : null;
  }

  function isBssReady(productId) {
    var B = window.BSS_B2B;
    if (!B || typeof B.formatMoney !== 'function' || !B.storage || !B.storage.productStorage) return false;
    if (!B.storage.productStorage.get(productId)) return false;
    if (!B.utils || typeof B.utils.checkCustomer !== 'function') return false;
    if (B.qb && B.qb.status && !(B.qb.utils && B.qb.utils.common)) return false;
    // Không chờ B.qi.utils: module QI của app có thể lỗi khi init (đọc rule trực tiếp, xem findQiRule)
    return true;
  }

  function qbCommon() {
    var B = window.BSS_B2B;
    return B.qb && B.qb.status && B.qb.utils ? B.qb.utils.common : null;
  }

  function qiRules() {
    var B = window.BSS_B2B;
    if (!B.qi || !B.qi.status) return [];
    if (B.qi.utils && B.qi.utils.product && B.qi.utils.product.listQiRule) return B.qi.utils.product.listQiRule;
    return B.qi.qiRules || [];
  }

  // ---------- điều kiện khách ----------

  function isCustomerAllowed() {
    var B = window.BSS_B2B;
    var customer = B.shopData && B.shopData.customer;
    if (!customer || customer.id == null) return false;
    if (CONFIG.customerTags.length) {
      var tags = (customer.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
      return CONFIG.customerTags.some(function (t) { return tags.indexOf(String(t).toLowerCase().trim()) !== -1; });
    }
    var common = qbCommon();
    if (!common) return false;
    return (common.listQbRule || []).some(function (rule) {
      return common.checkCustomer(structuredClone(rule));
    });
  }

  // ---------- Volume Pricing ----------

  // Rule VP áp cho khách + variant: rule khớp đầu tiên, giống trang sản phẩm.
  function findQbRule(product, variant) {
    var common = qbCommon();
    if (!common) return null;
    var QUANTITY = 0;
    var rules = common.listQbRule || [];
    for (var i = 0; i < rules.length; i++) {
      var rule = structuredClone(rules[i]);
      if (rule.rule_setting !== QUANTITY || !rule.qty_table || !rule.qty_table.length) continue;
      if (!common.checkCustomer(rule)) continue;
      var productCheck = Object.assign({}, product, { currentVariant: variant });
      if (common.checkProduct(rule, productCheck, false)) return rule; // rule.price = giá trước VP (cent)
    }
    return null;
  }

  function buildTiers(rule) {
    var B = window.BSS_B2B;
    var common = qbCommon();
    var L = CONFIG.labels;
    return rule.qty_table.slice().sort(function (a, b) {
      return Number(a.qty_from) - Number(b.qty_from);
    }).map(function (tier) {
      var info = common.getDiscountedPriceAndDiscountValue(tier, rule);
      var hasTo = hasValue(tier.qty_to);
      return {
        from: Number(tier.qty_from),
        label: fill(hasTo ? L.qtyRange : L.qtyOpen, { from: tier.qty_from, to: hasTo ? tier.qty_to : '' }),
        price: info ? B.formatMoney(info.originDiscountedPrice) : ''
      };
    });
  }

  // Giá trước VP (đã tính Price List nếu có), đơn vị cent.
  function basePrice(variantId, fallback) {
    var B = window.BSS_B2B;
    var stored = B.storage.variantStorage && B.storage.variantStorage.get(variantId);
    if (stored && B.utils && typeof B.utils.getInitialPrice === 'function') {
      var p = B.utils.getInitialPrice(stored, B.enum.QB_KEY);
      if (typeof p === 'number' && !isNaN(p)) return p;
    }
    return stored && typeof stored.price === 'number' ? stored.price : fallback;
  }

  // ---------- Quantity Increment ----------

  // Cùng điều kiện với module QI của app (QiUtils.checkCustomer / checkProduct), dùng utils chung của BSS.
  function findQiRule(product, variant) {
    var B = window.BSS_B2B;
    var rules = qiRules();
    var productCheck = Object.assign({}, product, { currentVariant: variant });
    for (var i = 0; i < rules.length; i++) {
      var rule = structuredClone(rules[i]);
      if (!rule.qty_increment) continue;
      if (!B.utils.checkCustomer(rule) || B.utils.checkExcludeCustomer(rule)) continue;
      if (!B.utils.checkProduct(rule, productCheck)) continue;
      var blocked = B.custom && B.custom.executeFilter('custom:block_qi', false, { rule: rule, product: productCheck, isCartPage: false }, false);
      if (blocked) continue;
      return rule;
    }
    return null;
  }

  // Số lượng kế tiếp theo bước nhảy: 1 → qiSmallMax nhảy bậc 1, lớn hơn thì theo bội của step.
  // dir: 1 = +, -1 = −, 0 = gõ tay (làm tròn về bội gần nhất, giống calculateNearestQuantity của app).
  // Vd step 6, qiSmallMax 5: + 4→5→6→12, − 12→6→5, gõ 4→4, 8→6, 9→12.
  function stepQty(qty, dir, step) {
    var small = Math.min(Math.max(0, Number(CONFIG.qiSmallMax) || 0), step - 1);
    if (step <= 1) return Math.max(0, qty + dir);
    if (dir > 0) return qty < small ? qty + 1 : (Math.floor(qty / step) + 1) * step;
    if (dir < 0) {
      if (qty <= step) return small ? Math.max(0, Math.min(qty - 1, small)) : 0;
      return (Math.ceil(qty / step) - 1) * step;
    }
    if (qty <= small) return qty;
    return Math.max(step, Math.round(qty / step) * step);
  }

  // Giới hạn trên: min(Stock, max của rule), làm tròn xuống theo bước nhảy (phần ≤ qiSmallMax giữ nguyên).
  function capQty(limit, step) {
    if (limit === Infinity || step <= 1) return limit;
    var small = Math.min(Math.max(0, Number(CONFIG.qiSmallMax) || 0), step - 1);
    var capped = Math.floor(limit / step) * step;
    return capped > 0 ? capped : Math.min(limit, small);
  }

  function isVariantQi(row) {
    return !!(row.qiRule && row.qiRule.qty_increment_type === QI_TYPE.VARIANT_QUANTITY);
  }

  function qtyStep(row) {
    return isVariantQi(row) ? Number(row.qiRule.qty_increment) : 1;
  }

  // Tối đa theo Stock đọc được (như bảng cũ dùng inventory_quantity) và qty_increment_max của rule.
  function qtyMax(row) {
    var stock = typeof row.stock === 'number' && row.stock > 0 ? row.stock : Infinity;
    var ruleMax = isVariantQi(row) && row.qiRule.qty_increment_max ? Number(row.qiRule.qty_increment_max) : Infinity;
    return capQty(Math.min(stock, ruleMax), qtyStep(row));
  }

  function normalizeQty(row, value) {
    var qty = Math.max(0, parseInt(value, 10) || 0);
    if (qty && isVariantQi(row)) qty = stepQty(qty, 0, qtyStep(row));
    return Math.min(qty, qtyMax(row));
  }

  // ---------- Stock ----------

  // Stock theo SKU, đọc text "Stock: N" / "SKU: X" trong từng dòng của bảng cũ.
  function readStockBySku() {
    var map = {};
    var container = document.querySelector(CONFIG.chartTableSelector);
    if (!container) return map;
    var rows = container.querySelectorAll('tr, li');
    for (var i = 0; i < rows.length; i++) {
      var text = rows[i].textContent || '';
      var sku = text.match(/SKU:\s*([^\s]+)/i);
      var stock = text.match(/Stock:\s*(-?\d+)/i);
      if (sku && stock) map[sku[1]] = Number(stock[1]);
    }
    return map;
  }

  function stockState(row, stockBySku) {
    var L = CONFIG.labels;
    var hasNumber = row.sku && Object.prototype.hasOwnProperty.call(stockBySku, row.sku);
    if (hasNumber) row.stock = stockBySku[row.sku];
    var inStock = hasNumber ? stockBySku[row.sku] > 0 : row.available;
    return { inStock: inStock, text: hasNumber ? stockBySku[row.sku] : inStock ? L.inStock : L.outOfStock };
  }

  // ---------- dữ liệu dòng ----------

  function buildRows(productJson, storageProduct) {
    var names = (productJson.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var storageVariants = storageProduct.variants || [];
    var rows = [];
    productJson.variants.forEach(function (v) {
      var sv = storageVariants.filter(function (x) { return Number(x.id) === Number(v.id); })[0];
      if (!sv) return;
      var qbRule = findQbRule(storageProduct, sv);
      rows.push({
        id: Number(v.id),
        sku: v.sku || '',
        barcode: v.barcode || '',
        available: !!v.available,
        title: v.name || v.title,
        image: (v.featured_image && v.featured_image.src) || productJson.featured_image || '',
        optionLines: (v.options || []).map(function (value, i) { return { name: names[i] || '', value: value }; }),
        qbRule: qbRule,
        tiers: qbRule ? buildTiers(qbRule) : null,
        basePrice: qbRule ? Number(qbRule.price) : basePrice(v.id, v.price),
        qiRule: findQiRule(storageProduct, sv),
        stock: null,
        qty: 0
      });
    });
    return rows;
  }

  // Đơn giá theo mức VP. Số lượng: của riêng dòng (tierQuantityBy 'row') hoặc theo loại rule như ở cart.
  function unitPrice(row, rows) {
    if (!row.qbRule) return { price: row.basePrice, tierFrom: null };
    var totalValue = row.qty;
    var byRule = CONFIG.tierQuantityBy === 'rule';
    if (byRule && (row.qbRule.rule_type === QB_TYPE.PRODUCT_LEVEL || row.qbRule.rule_type === QB_TYPE.ORDER_LEVEL)) {
      totalValue = rows.reduce(function (sum, r) {
        return r.qbRule && r.qbRule.id === row.qbRule.id ? sum + r.qty : sum;
      }, 0);
    }
    var res = totalValue > 0 ? qbCommon().getAppliedItemAndDiscountInfo(row.qbRule, totalValue) : null;
    if (res && res.appliedItem && res.discountInfo) {
      return { price: res.discountInfo.originDiscountedPrice, tierFrom: Number(res.appliedItem.qty_from) };
    }
    return { price: row.basePrice, tierFrom: null };
  }

  // ---------- render ----------

  function rowHtml(row, index, stockBySku) {
    var L = CONFIG.labels;
    var B = window.BSS_B2B;
    var stock = stockState(row, stockBySku);
    var max = qtyMax(row);
    var tiersHtml;
    if (row.tiers && row.tiers.length) {
      tiersHtml =
        '<table class="' + ROOT_CLASS + '__tiers">' +
          '<thead><tr><th>' + escapeHtml(L.tierQty) + '</th><th>' + escapeHtml(L.tierPrice) + '</th></tr></thead>' +
          '<tbody>' + row.tiers.map(function (t) {
            return '<tr data-tier-from="' + t.from + '"><td>' + escapeHtml(t.label) + '</td>' +
              '<td class="' + ROOT_CLASS + '__tier-price">' + escapeHtml(t.price) + '</td></tr>';
          }).join('') + '</tbody>' +
        '</table>';
    } else {
      tiersHtml = '<div class="' + ROOT_CLASS + '__base-price">' + escapeHtml(B.formatMoney(row.basePrice)) + '</div>';
    }

    return '<tr data-row="' + index + '">' +
      '<td><div class="' + ROOT_CLASS + '__variant">' +
        (row.image ? '<img src="' + escapeHtml(sizedImage(row.image, 200)) + '" alt="' + escapeHtml(row.title) + '" loading="lazy" width="84" height="84">' : '') +
        row.optionLines.map(function (o) { return '<div>' + escapeHtml(o.name) + ' : ' + escapeHtml(o.value) + '</div>'; }).join('') +
      '</div></td>' +
      '<td class="' + ROOT_CLASS + '__info">' +
        '<div data-bss-stock-sku="' + escapeHtml(row.sku) + '">' + escapeHtml(L.stock) + ': ' +
          '<span class="' + ROOT_CLASS + '__stock ' + ROOT_CLASS + (stock.inStock ? '__stock--in' : '__stock--out') + '">' + escapeHtml(stock.text) + '</span></div>' +
        (row.sku ? '<div>' + escapeHtml(L.sku) + ': ' + escapeHtml(row.sku) + '</div>' : '') +
        (row.barcode ? '<div>' + escapeHtml(L.upc) + ': ' + escapeHtml(row.barcode) + '</div>' : '') +
      '</td>' +
      '<td class="' + ROOT_CLASS + '__tiers-cell">' + tiersHtml + '</td>' +
      '<td><span class="' + ROOT_CLASS + '__amount">' +
        // step="1": 1 → qiSmallMax là số hợp lệ, bước nhảy thật do JS xử lý
        '<input class="' + ROOT_CLASS + '__qty" type="number" inputmode="numeric" min="0" step="1" value="0"' +
          (max !== Infinity ? ' max="' + max + '"' : '') +
          ' data-row="' + index + '" aria-label="' + escapeHtml(L.quantity + ' ' + row.title) + '"' +
          (row.available ? '' : ' disabled') + '>' +
        '<button type="button" class="' + ROOT_CLASS + '__incr" data-row="' + index + '" data-dir="1" aria-label="' + escapeHtml(L.increase) + '"' + (row.available ? '' : ' disabled') + '>' +
          '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 5l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
        '<button type="button" class="' + ROOT_CLASS + '__decr" data-row="' + index + '" data-dir="-1" aria-label="' + escapeHtml(L.decrease) + '" disabled>' +
          '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
      '</span></td>' +
    '</tr>';
  }

  function renderTable(rows) {
    var L = CONFIG.labels;
    var stockBySku = readStockBySku();
    var wrapper = document.createElement('div');
    wrapper.className = ROOT_CLASS;
    wrapper.innerHTML =
      '<div class="' + ROOT_CLASS + '__scroll"><table class="' + ROOT_CLASS + '__table">' +
        '<colgroup><col><col><col><col></colgroup>' +
        '<thead><tr><th>' + escapeHtml(L.variant) + '</th><th>' + escapeHtml(L.info) + '</th><th>' +
          escapeHtml(rows.some(function (r) { return r.tiers; }) ? L.tiers : L.noTiers) + '</th><th>' + escapeHtml(L.quantity) + '</th></tr></thead>' +
        '<tbody>' + rows.map(function (r, i) { return rowHtml(r, i, stockBySku); }).join('') + '</tbody>' +
      '</table></div>' +
      '<div class="' + ROOT_CLASS + '__footer">' +
        '<button type="button" class="' + ROOT_CLASS + '__add" disabled>' + escapeHtml(L.addToCart) + '</button>' +
        '<div class="' + ROOT_CLASS + '__total" aria-live="polite"></div>' +
      '</div>' +
      '<div class="' + ROOT_CLASS + '__message" role="status" aria-live="polite"></div>';
    return wrapper;
  }

  // Cập nhật Total, nút Add to cart và dòng tier đang áp.
  function refresh(wrapper, rows) {
    var B = window.BSS_B2B;
    var L = CONFIG.labels;
    var totalQty = 0;
    var totalPrice = 0;
    rows.forEach(function (row, i) {
      var unit = unitPrice(row, rows);
      totalQty += row.qty;
      totalPrice += unit.price * row.qty;
      var tierRows = wrapper.querySelectorAll('tr[data-row="' + i + '"] tr[data-tier-from]');
      for (var k = 0; k < tierRows.length; k++) {
        var active = unit.tierFrom !== null && Number(tierRows[k].getAttribute('data-tier-from')) === unit.tierFrom;
        tierRows[k].classList.toggle(ROOT_CLASS + '__tier--active', active);
      }
      // Trạng thái nút +/−
      var incr = wrapper.querySelector('.' + ROOT_CLASS + '__incr[data-row="' + i + '"]');
      var decr = wrapper.querySelector('.' + ROOT_CLASS + '__decr[data-row="' + i + '"]');
      if (incr) incr.disabled = !row.available || stepQty(row.qty, 1, qtyStep(row)) > qtyMax(row);
      if (decr) decr.disabled = !row.available || row.qty <= 0;
    });
    wrapper.querySelector('.' + ROOT_CLASS + '__total').textContent =
      fill(L.total, { qty: totalQty, price: B.formatMoney(Math.round(totalPrice)) });
    wrapper.querySelector('.' + ROOT_CLASS + '__add').disabled = totalQty === 0;
  }

  function showMessage(wrapper, text, isError) {
    var el = wrapper.querySelector('.' + ROOT_CLASS + '__message');
    el.textContent = text || '';
    el.className = ROOT_CLASS + '__message' + (isError ? ' ' + ROOT_CLASS + '__message--error' : '');
    if (isError && text) {
      // Alert chung của theme (giống bảng cũ)
      window.dispatchEvent(new CustomEvent('showAlert', { detail: { message: text, type: 'error' } }));
    }
  }

  // Rule QI tính theo tổng số lượng sản phẩm: kiểm tra trước khi add.
  function productIncrementError(rows) {
    var byRule = {};
    rows.forEach(function (row) {
      if (!row.qiRule || row.qiRule.qty_increment_type !== QI_TYPE.PRODUCT_QUANTITY) return;
      var key = row.qiRule.id;
      byRule[key] = byRule[key] || { step: row.qiRule.qty_increment, qty: 0 };
      byRule[key].qty += row.qty;
    });
    for (var key in byRule) {
      if (byRule[key].qty > 0 && byRule[key].qty % byRule[key].step !== 0) {
        return fill(CONFIG.labels.multipleOf, { step: byRule[key].step });
      }
    }
    return null;
  }

  function refreshThemeCart() {
    // Mini cart của theme Xtra (cùng cách bảng cũ dùng sau khi add)
    if (typeof ajaxCart !== 'undefined' && ajaxCart && typeof ajaxCart.load === 'function') {
      ajaxCart.load(false, true, false, true);
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var count = document.getElementById('cart-count');
        if (count) count.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  function addToCart(wrapper, rows, button) {
    var L = CONFIG.labels;
    var error = productIncrementError(rows);
    if (error) return showMessage(wrapper, error, true);

    var items = rows.filter(function (r) { return r.qty > 0; }).map(function (r) {
      return { id: r.id, quantity: r.qty };
    });
    if (!items.length) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    button.disabled = true;
    button.textContent = L.adding;
    showMessage(wrapper, '');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          var desc = result.data && result.data.description;
          var text = typeof desc === 'string' ? desc : desc && typeof desc === 'object' ? Object.values(desc).join(' ') : L.addError;
          showMessage(wrapper, text, true);
          return;
        }
        rows.forEach(function (r) { r.qty = 0; });
        var inputs = wrapper.querySelectorAll('.' + ROOT_CLASS + '__qty');
        for (var i = 0; i < inputs.length; i++) inputs[i].value = 0;
        showMessage(wrapper, L.added, false);
        refreshThemeCart();
      })
      .catch(function () {
        showMessage(wrapper, L.addError, true);
      })
      .then(function () {
        button.textContent = L.addToCart;
        refresh(wrapper, rows);
      });
  }

  function bindEvents(wrapper, rows) {
    function onQtyChange(e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains(ROOT_CLASS + '__qty')) return;
      var row = rows[Number(input.getAttribute('data-row'))];
      if (!row) return;
      if (e.type === 'change') {
        row.qty = normalizeQty(row, input.value);
        input.value = row.qty;
      } else {
        row.qty = Math.max(0, parseInt(input.value, 10) || 0);
      }
      showMessage(wrapper, '');
      refresh(wrapper, rows);
    }
    wrapper.addEventListener('input', onQtyChange);
    wrapper.addEventListener('change', onQtyChange);
    // Nút +/−: tăng giảm theo bước nhảy QI (1 → qiSmallMax bậc 1, sau đó theo bậc của rule)
    wrapper.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-dir]');
      if (!btn || btn.disabled || !wrapper.contains(btn)) return;
      var i = Number(btn.getAttribute('data-row'));
      var row = rows[i];
      var input = wrapper.querySelector('.' + ROOT_CLASS + '__qty[data-row="' + i + '"]');
      if (!row || !input) return;
      var current = normalizeQty(row, input.value);
      var next = stepQty(current, Number(btn.getAttribute('data-dir')) > 0 ? 1 : -1, qtyStep(row));
      row.qty = Math.max(0, Math.min(next, qtyMax(row)));
      input.value = row.qty;
      showMessage(wrapper, '');
      refresh(wrapper, rows);
    });
    var button = wrapper.querySelector('.' + ROOT_CLASS + '__add');
    button.addEventListener('click', function () {
      // Áp bội số cho ô đang gõ dở trước khi add
      rows.forEach(function (row, i) {
        var input = wrapper.querySelector('.' + ROOT_CLASS + '__qty[data-row="' + i + '"]');
        row.qty = normalizeQty(row, input.value);
        input.value = row.qty;
      });
      refresh(wrapper, rows);
      addToCart(wrapper, rows, button);
    });
  }

  // Bảng cũ có thể render sau: cập nhật lại Stock vài lần.
  function refreshStockLater(wrapper, rows) {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      var stockBySku = readStockBySku();
      rows.forEach(function (row) {
        if (!row.sku || !Object.prototype.hasOwnProperty.call(stockBySku, row.sku)) return;
        var cell = wrapper.querySelector('[data-bss-stock-sku="' + (window.CSS && CSS.escape ? CSS.escape(row.sku) : row.sku) + '"] .' + ROOT_CLASS + '__stock');
        if (!cell) return;
        var state = stockState(row, stockBySku);
        cell.textContent = state.text;
        cell.className = ROOT_CLASS + '__stock ' + ROOT_CLASS + (state.inStock ? '__stock--in' : '__stock--out');
        var input = wrapper.querySelector('.' + ROOT_CLASS + '__qty[data-row="' + rows.indexOf(row) + '"]');
        var max = qtyMax(row);
        if (input && max !== Infinity) input.setAttribute('max', max);
      });
      refresh(wrapper, rows);
      if (attempts >= 10) clearInterval(timer);
    }, 500);
  }

  function injectStyles() {
    if (document.getElementById(ROOT_CLASS + '-style')) return;
    var c = '.' + ROOT_CLASS;
    var q = ':is(#root, html) ' + c + ' ' + c; // ưu tiên cao hơn style chung của theme
    var css = [
      // Bảng nằm trong cột thông tin sản phẩm (~535px ở desktop): co theo độ rộng cột, không cuộn ngang.
      c + '{margin:16px 0;container-type:inline-size}',
      c + '__scroll{overflow-x:visible}',
      c + '__table{width:100%;table-layout:fixed;border-collapse:collapse;background:#fff}',
      c + '__table > colgroup > col:nth-child(1){width:20%}',
      c + '__table > colgroup > col:nth-child(2){width:27%}',
      c + '__table > colgroup > col:nth-child(3){width:35%}',
      c + '__table > colgroup > col:nth-child(4){width:18%}',
      c + '__table th{background:#2d3a52;color:#fff;font-weight:500;padding:12px 6px;text-align:center;border:1px solid #2d3a52;overflow-wrap:anywhere}',
      c + '__table td{border:1px solid #2d3a52;padding:10px 6px;text-align:center;vertical-align:middle;line-height:1.5;overflow-wrap:anywhere}',
      c + '__variant{display:flex;flex-direction:column;align-items:center;gap:4px;font-size:.9em}',
      c + '__variant img{width:64px;height:64px;max-width:100%;object-fit:contain}',
      c + '__info{font-size:.9em}',
      c + '__stock{font-weight:600}',
      c + '__stock--in{color:#2e7d32}',
      c + '__stock--out{color:#c62828}',
      c + '__table td' + c + '__tiers-cell{padding:6px}',
      c + '__table ' + c + '__tiers{width:100%;table-layout:auto;border-collapse:collapse;line-height:1.35;font-size:.9em}',
      c + '__table ' + c + '__tiers th{background:#eef1f6;color:#2d3a52;font-weight:600;font-size:.85em;padding:5px 4px;border:0;border-bottom:1px solid #c9d0dc}',
      c + '__table ' + c + '__tiers td{border:0;border-bottom:1px solid #e3e7ee;padding:5px 4px;white-space:nowrap}',
      c + '__table ' + c + '__tiers tr:last-child td{border-bottom:0}',
      c + '__table ' + c + '__tiers tr' + c + '__tier--active td{background:#2d3a52;color:#fff}',
      c + '__tier-price{font-weight:600}',
      c + '__base-price{font-weight:600}',
      // Ô số lượng có nút +/− xếp dọc bên phải, giống bảng cũ của theme.
      // Theme style input/button bằng selector có id (#root ...): dùng :is(#root, html) + !important để không bị đè.
      q + '__amount{position:relative!important;display:inline-block!important;width:100%!important;max-width:92px!important;height:48px!important;margin:0!important;padding:0!important;vertical-align:middle}',
      q + '__qty{display:block!important;width:100%!important;height:48px!important;min-height:0!important;margin:0!important;padding:0 28px 0 10px!important;text-align:center!important;border:1px solid #e3e7ee!important;border-radius:6px!important;background:#fff!important;color:inherit!important;font:inherit!important;box-shadow:none!important;-moz-appearance:textfield!important;appearance:textfield!important;box-sizing:border-box!important}',
      q + '__qty::-webkit-outer-spin-button,' + q + '__qty::-webkit-inner-spin-button{-webkit-appearance:none!important;margin:0!important}',
      q + '__incr,' + q + '__decr{all:unset!important;position:absolute!important;right:1px!important;z-index:2!important;display:flex!important;align-items:center!important;justify-content:center!important;width:26px!important;height:23px!important;color:#2d3a52!important;cursor:pointer!important;box-sizing:border-box!important}',
      q + '__incr{top:1px!important}',
      q + '__decr{bottom:1px!important}',
      q + '__incr:focus-visible,' + q + '__decr:focus-visible{outline:2px solid #2d3a52!important;outline-offset:-2px!important}',
      q + '__incr svg,' + q + '__decr svg{display:block!important;width:10px!important;height:6px!important}',
      q + '__incr:disabled,' + q + '__decr:disabled{opacity:.3!important;cursor:default!important}',
      c + '__footer{display:flex;justify-content:space-between;align-items:center;gap:16px;flex-wrap:wrap;margin-top:20px}',
      q + '__incr::before,' + q + '__incr::after,' + q + '__decr::before,' + q + '__decr::after,' + q + '__add::before,' + q + '__add::after{content:none!important;display:none!important}',
      q + '__add{min-height:52px!important;min-width:260px!important;margin:0!important;padding:0 24px!important;border:0!important;border-radius:6px!important;background:#2d3a52!important;color:#fff!important;font:inherit!important;font-weight:600!important;letter-spacing:.04em!important;cursor:pointer!important;box-shadow:none!important}',
      q + '__add:disabled{background:#6b7280!important;cursor:not-allowed!important}',
      c + '__total{font-weight:700;font-size:1.15em}',
      c + '__message{margin-top:10px;color:#2e7d32}',
      c + '__message--error{color:#c62828}',
      // Cột hẹp (mobile / màn nhỏ): mỗi variant thành 1 thẻ, ảnh + info trên, tiered pricing, quantity bên dưới.
      '@container (max-width: 460px){' +
        c + '__table > thead{display:none}' +
        c + '__table, ' + c + '__table > tbody{display:block}' +
        c + '__table > tbody > tr{display:grid;grid-template-columns:96px 1fr;border:1px solid #2d3a52;margin-bottom:12px}' +
        c + '__table > tbody > tr > td{border:0;border-bottom:1px solid #e3e7ee}' +
        c + '__table > tbody > tr > td' + c + '__tiers-cell, ' + c + '__table > tbody > tr > td:last-child{grid-column:1 / -1}' +
        c + '__table > tbody > tr > td:last-child{border-bottom:0}' +
        c + '__info{text-align:left!important}' +
      '}',
      // App chèn bảng VP ngay trước div .bss-b2b-qb-table, gắn attribute bss-b2b-qb-product-table
      'body.' + ROOT_CLASS + '--hide-vp ' + CONFIG.insertBeforeSelector + ' [bss-b2b-qb-product-table]{display:none!important}',
      'body.' + ROOT_CLASS + '--hide-chart ' + CONFIG.chartTableSelector + '{display:none!important}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = ROOT_CLASS + '-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ---------- Cart: QI 1 → qiSmallMax bậc 1 ----------

  function smallMaxFor(rule) {
    var step = Number(rule && rule.qty_increment) || 1;
    return Math.min(Math.max(0, Number(CONFIG.qiSmallMax) || 0), step - 1);
  }

  // Validate QI của app khi bấm checkout (QiCart.validate → filter custom:cart/recheck_qi):
  // bỏ báo lỗi cho dòng có số lượng 1 → qiSmallMax. Thêm vào bssB2BHooks có sẵn, không ghi đè filter khác.
  function registerQiHooks() {
    if (!(Number(CONFIG.qiSmallMax) > 0)) return;
    window.bssB2BHooks = window.bssB2BHooks || {};
    window.bssB2BHooks.filters = window.bssB2BHooks.filters || {};
    var filters = window.bssB2BHooks.filters;
    var prev = filters['custom:cart/recheck_qi'];
    if (prev && prev.__bssVpMerged) return;
    var hook = function (data, args) {
      if (typeof prev === 'function') data = prev(data, args);
      if (!data || !data.invalidProductMap || typeof data.invalidProductMap.forEach !== 'function') return data;
      data.invalidProductMap.forEach(function (item, key) {
        var rule = item && item.appliedRule;
        if (!rule || rule.qty_increment_type !== QI_TYPE.VARIANT_QUANTITY) return;
        var qty = Number(item.quantity);
        var max = rule.qty_increment_max ? Number(rule.qty_increment_max) : Infinity;
        if (qty >= 1 && qty <= smallMaxFor(rule) && qty <= max) data.invalidProductMap.delete(key);
      });
      return data;
    };
    hook.__bssVpMerged = true;
    filters['custom:cart/recheck_qi'] = hook;
  }

  // Nút +/− và ô số lượng của theme trên cart page.
  // Theme gửi /cart/change ngay trong listener của nó, trước khi module QI của app chỉnh số lượng,
  // nên phải tính số lượng ở capture phase (trước theme), rồi để theme tự gửi request như bình thường.
  function initCartQtyFix() {
    if (!CONFIG.cartQtyFix || window.__bssVpMergedCartFix) return;
    window.__bssVpMergedCartFix = true;
    var ITEM = 'li[bss-b2b-cart-item-key]';
    var INPUT = 'input[name="updates[]"]';

    function getRule(input) {
      var item = input.closest(ITEM);
      var key = item && item.getAttribute('bss-b2b-cart-item-key');
      var B = window.BSS_B2B;
      var cartItem = key && B && B.storage && B.storage.cartStorage && B.storage.cartStorage.get(key);
      var rule = cartItem && cartItem.appliedQI;
      return rule && rule.qty_increment_type === QI_TYPE.VARIANT_QUANTITY && Number(rule.qty_increment) > 1 ? rule : null;
    }

    // Giới hạn trên: min(max của rule, tồn kho của theme ở input.max)
    function maxFor(rule, input) {
      var stock = Number(input.getAttribute('max')) || Infinity;
      var ruleMax = rule.qty_increment_max ? Number(rule.qty_increment_max) : Infinity;
      return capQty(Math.min(stock, ruleMax), Number(rule.qty_increment));
    }

    window.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest(ITEM + ' a.incr, ' + ITEM + ' a.decr');
      if (!btn) return;
      var input = btn.closest(ITEM).querySelector(INPUT);
      var rule = input && getRule(input);
      if (!rule) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var current = Number(input.value) || 0;
      var next = stepQty(current, btn.classList.contains('incr') ? 1 : -1, Number(rule.qty_increment));
      // Không xuống 0 bằng nút −: xóa dòng dùng nút remove của theme
      next = Math.max(1, Math.min(next, maxFor(rule, input)));
      if (next === current) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);

    window.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.matches || !input.matches(ITEM + ' ' + INPUT)) return;
      var rule = getRule(input);
      if (!rule) return;
      var current = Number(input.value);
      if (!Number.isInteger(current) || current <= 0) return; // 0 = xóa dòng, để theme xử lý
      var next = Math.max(1, Math.min(stepQty(current, 0, Number(rule.qty_increment)), maxFor(rule, input)));
      if (next !== current) input.value = next;
    }, true);

    patchAppQiCart();
  }

  // Module QI của app (QiCart.handleChangeQuantity) chạy sau khi theme đã gửi /cart/change, rồi gán lại ô số lượng
  // theo calculateNearestQuantity: 1 → qiSmallMax bị làm tròn lên bậc đầu (vd 2 → 6). Ô hiện 6 cho tới khi theme
  // render lại cart với số đúng. Ghi đè hàm này trên instance cart để app tính cùng kết quả với stepQty.
  function patchAppQiCart() {
    var startedAt = Date.now();
    (function tryPatch() {
      var B = window.BSS_B2B;
      var cart = B && B.qi && B.qi.utils && B.qi.utils.cart;
      if (!cart || typeof cart.calculateNearestQuantity !== 'function') {
        if (Date.now() - startedAt < CONFIG.waitTimeoutMs) setTimeout(tryPatch, 200);
        return;
      }
      if (cart.__bssVpMergedPatched) return;
      cart.__bssVpMergedPatched = true;
      var original = cart.calculateNearestQuantity;
      cart.calculateNearestQuantity = function (rule, curQuantity, changeType) {
        var step = Number(rule && rule.qty_increment) || 1;
        // Chỉ thay kiểu gõ tay (InputQuantity) của rule theo variant; +/− đã được xử lý ở listener click phía trên
        if (changeType !== 'InputQuantity' || !rule || rule.qty_increment_type !== QI_TYPE.VARIANT_QUANTITY || step <= 1) {
          return original.apply(this, arguments);
        }
        var qty = Number(curQuantity);
        if (!Number.isInteger(qty) || qty <= 0) return original.apply(this, arguments);
        var ruleMax = rule.qty_increment_max ? Number(rule.qty_increment_max) : Infinity;
        return Math.max(1, Math.min(stepQty(qty, 0, step), capQty(ruleMax, step)));
      };
    })();
  }

  // ---------- init ----------

  function init() {
    var handle = getHandle();
    if (!isEnabledFor(handle)) return;
    var anchor = document.querySelector(CONFIG.insertBeforeSelector);
    var productId = getProductId();
    // Chỉ thay ở sản phẩm đang có bảng cũ
    if (!anchor || !productId || !document.querySelector(CONFIG.chartTableSelector)) return;
    if (document.querySelector('.' + ROOT_CLASS)) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var productJsonPromise = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('product.js ' + res.status);
        return res.json();
      });

    Promise.all([productJsonPromise, waitFor(function () { return isBssReady(productId); }, CONFIG.waitTimeoutMs)])
      .then(function (results) {
        if (!isCustomerAllowed()) return;
        var storageProduct = window.BSS_B2B.storage.productStorage.get(productId);
        var rows = buildRows(results[0], storageProduct);
        if (!rows.length) return;

        injectStyles();
        var wrapper = renderTable(rows);
        anchor.insertAdjacentElement('beforebegin', wrapper);
        bindEvents(wrapper, rows);
        refresh(wrapper, rows);
        if (CONFIG.hideDefaultVpTable) document.body.classList.add(ROOT_CLASS + '--hide-vp');
        // Bảng mới đã có Add to cart: lúc này mới ẩn bảng cũ
        if (CONFIG.hideChartTable) document.body.classList.add(ROOT_CLASS + '--hide-chart');
        refreshStockLater(wrapper, rows);
      })
      .catch(function (err) {
        console.warn('[BSS custom] VP merged table:', err && err.message ? err.message : err);
      });
  }

  registerQiHooks();
  initCartQtyFix();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
